export default {"src":"/_next/static/media/logo-depotium.581cb8df.svg","height":220,"width":620};